export enum LocaleStorageKeys {
  NavbarCollapsed = "noan-navbar-collapsed",
  FirstSessionLogin = "noan-first-session-login",
  DashboardAssistantUnlocked = "noan-dashboard-assistant-unlocked",
  ExtraStackUnlocked = "noan-extra-stack-unlocked",
  FirstBlockCompleted = "noan-first-block-completed",
  CreateModePinged = "noan-create-mode-pinged",
  FirstUseBlockNav = "noan-first-use-block-nav",
  UICollapsible = "noan-ui-collapsible",
}
